/* eslint-disable react/jsx-props-no-spreading */
/**
 * Prop spreading is required to pass the props to the Modal component.
 *
 *
 */
import React, { useState } from 'react';
import {
  Button, ButtonProps, Modal, ModalProps,
} from 'react-bootstrap';
import clsx from 'clsx';
import { LoadingSpinner } from './LoadingSpinner';

interface ControlledModalProps extends ModalProps {
  title: string;
  description?: string;
  closeButton: boolean;
  triggerButton?: ButtonProps;
}

export function ControlledModal(props: ControlledModalProps) {
  const {
    title, description, children, closeButton, triggerButton, ...rest
  } = props;

  const [controlledShow, setControlledShow] = useState(false);
  const useButtonTrigger = rest.show === undefined;
  return (
    <>
      {useButtonTrigger && (
      <Button variant="primary" onClick={() => setControlledShow(true)} {...triggerButton}>
        {title}
      </Button>
      )}
      <Modal show={controlledShow} onHide={() => setControlledShow(false)} {...rest} contentClassName="controlled-modal">
        <Modal.Header closeButton={closeButton}>
          <Modal.Title className="modal-title">{title}</Modal.Title>
        </Modal.Header>
        {description && <p className="modal-description">{description}</p>}
        {children}
      </Modal>
    </>
  );
}

interface ControlledModalActionsProps {
  handleClose: () => void;
  isPending?: boolean;
  container?: React.HTMLAttributes<HTMLDivElement>;
  submitButtonProps?: ButtonProps
  cancelButton?: boolean;
  cancelButtonProps?: ButtonProps;
}

function ControlledModalActions(props: ControlledModalActionsProps) {
  return (
    <div className={clsx('modal-actions', props.container?.className)} {...props.container}>
      <Button
        variant="outline-primary"
        hidden={!props.cancelButton}
        disabled={props.isPending}
        onClick={props.handleClose}
        {...props.cancelButtonProps}
      >
        Cancelar
      </Button>
      <Button
        variant="primary"
        disabled={props.isPending}
        type="submit"
        {...props.submitButtonProps}
      >
        {props.isPending && <LoadingSpinner size={13} color="white" />}
        Guardar
      </Button>
    </div>
  );
}

ControlledModal.Actions = ControlledModalActions;

interface ControlledAlertModalActionsProps {
  handleClose: () => void;
  onConfirm: () => void;
  container?: React.HTMLAttributes<HTMLDivElement>;
  isPending?: boolean;
}

function ControlledAlertModalActions(props: ControlledAlertModalActionsProps) {
  return (
    <div className={clsx('modal-actions', props.container?.className)} {...props.container}>
      <Button
        variant="outline-primary"
        disabled={props.isPending}
        onClick={props.handleClose}
      >
        Cancelar
      </Button>
      <Button variant="primary" disabled={props.isPending} onClick={props.onConfirm}>
        {props.isPending && <LoadingSpinner size={13} color="white" />}
        Confirmar
      </Button>
    </div>
  );
}

export function ControlledAlertModal(props: ControlledModalProps) {
  const {
    title, description, children, closeButton, triggerButton, ...rest
  } = props;
  const [controlledShow, setControlledShow] = useState(false);
  const useButtonTrigger = rest.show === undefined;
  return (
    <>
      {useButtonTrigger && (
      <Button variant="primary" onClick={() => setControlledShow(true)} {...triggerButton}>
        {title}
      </Button>
      )}
      <Modal show={controlledShow} onHide={() => setControlledShow(false)} {...rest}>
        <Modal.Header closeButton={closeButton}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        {description && <p className="modal-description">{description}</p>}
        {children}
      </Modal>
    </>
  );
}

ControlledAlertModal.Actions = ControlledAlertModalActions;
